import { MenuItem, styled, SxProps } from '@mui/material';

export const SelectMenuPaperSx: SxProps = {
  marginTop: '8px',
  backgroundColor: 'var(--dk-bg, white)',
  boxShadow: '0 6px 12px 0px rgba(0, 0, 0, 0.08)',
  border: '1px solid #000',
  borderRadius: '8px',
  '& .MuiList-root': {
    padding: '10px',
    maxHeight: '215px',
    overflowY: 'auto',
  },
};

export const SelectMenuItem = styled(MenuItem)`
  margin-bottom: 2px;
  padding: 6px;
  font-weight: 400;
  font-size: 14px;
  color: var(--dk-text, black);
  &:hover {
    background: var(--dk-bg-muted, rgb(243, 245, 246));
  }
`;

/**
 * `plain` 셰브론 크기(시안 `selectBox` = 28).
 * 아이콘을 절대배치하고 select 오른쪽에 **같은 폭**을 비워두기 때문에 한 값으로 묶는다.
 * 바꿀 거면 둘이 같이 움직여야 화살표 클릭 영역이 안 어긋난다.
 */
export const PLAIN_SELECT_ICON_SIZE = 28;

/**
 * `variant="plain"` — 보더·배경 없이 값 + 화살표만 남긴다.
 * 시안의 `selectBox`(툴바 년/월)처럼 인라인으로 놓는 자리용. 패딩이 없다.
 *
 * 특이도 주의 — 이 변형이 걷어내야 하는 기본값은 두 군데서 온다.
 * 1. 전역 테마(`theme/overrides/TextField.ts`)가 `&.MuiInputBase-input` 으로
 *    `padding 12 / font 14 / lh 20` 을 박는다. 같은 엘리먼트 클래스 2개라 (0,2,0) —
 *    `& .MuiSelect-select` 로는 동점이라 밀린다. 클래스를 하나 더 물려 (0,3,0) 으로 이긴다.
 * 2. MUI 는 select 오른쪽에 `&&&`(0,3,0) 로 패딩 32 를 잡는다. `!important` 아니면 안 지워진다.
 *
 * 아이콘은 MUI 구조 그대로 **절대배치로 둔다.** 흐름 배치로 빼면 클릭 핸들러가 붙은
 * `.MuiSelect-select` 바깥에 서게 돼서 화살표를 눌러도 안 열린다.
 * 대신 비워두는 폭을 32 → 28 로 줄여 시안처럼 글자 바로 옆에 붙인다.
 */
export const PlainSelectSx: SxProps = {
  background: 'transparent',
  // 테마가 `&.MuiInputBase-root` 로 높이 44 를 박아서 루트에도 클래스를 물려야 한다
  '&.MuiInputBase-root': { height: 'auto' },
  '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    border: 'none !important',
  },
  '& .MuiSelect-select.MuiInputBase-input': {
    display: 'inline-flex',
    alignItems: 'center',
    padding: 0,
    // 셰브론이 앉을 자리. 아이콘이 이 위를 덮으므로 여기가 곧 화살표 클릭 영역이다
    paddingRight: `${PLAIN_SELECT_ICON_SIZE}px !important`,
    height: 'auto',
    minHeight: 'auto',
    // 글자 크기·굵기·행간은 호출부가 루트 `sx` 로 정한다 (테마의 14/20 을 덮는다)
    fontSize: 'inherit',
    fontWeight: 'inherit',
    lineHeight: 'inherit',
  },
  '& .MuiSelect-icon': {
    right: 0,
    // `translateY` 로 가운데 맞추면 열릴 때 붙는 `rotate(180deg)` 가 그걸 덮어써서 튄다.
    // 아이콘 높이가 고정이라 top 계산으로 세운다.
    top: `calc(50% - ${PLAIN_SELECT_ICON_SIZE / 2}px)`,
    width: PLAIN_SELECT_ICON_SIZE,
    height: PLAIN_SELECT_ICON_SIZE,
    // MUI 는 아이콘에 `palette.action.active`(검정 54%) 를 물린다. 셰브론 svg 가
    // `currentColor` 라 그대로 두면 글자보다 흐려진다 → 글자색을 따라가게 한다
    color: 'inherit',
    // 클릭이 밑의 select 로 내려가야 화살표를 눌러도 열린다
    pointerEvents: 'none',
  },
  display: 'inline-flex',
  alignItems: 'center',
  cursor: 'pointer',
};
